import React from "react";

import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const dummyData = [
  { name: "Group A", value: 500 },
  { name: "Group B", value: 800 },
  // { name: "Group C", value: 300 },
  // { name: "Group D", value: 200 },
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  // return (
  //   <text x={x} y={y} textAnchor={x > cx ? "start" : "end"}>
  //     {`${(percent * 100).toFixed(0)}%`}
  //   </text>
  // );
};

const Piechart = (props) => {
  const width = props.width || 200;
  const height = props.height || 300;
  const radius = props.radius || 100;

  const data = props.data || "Year - 2022";
  //  dummyData;
  const colors = props.colors || ["#5E3FBE", "#E7DCFF"];

  return (
    <ResponsiveContainer width={width} height={height}>
      <PieChart width={width} height={height}>
        <Tooltip />
        <Pie
          data={data}
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={radius}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default Piechart;
